import css from "./style.module.scss";

export default function Loader() {
  return (
    <div className={css.loader}>
      <div></div>
    </div>
  );
}
